export const env = {
	NODE_ENV: process.env.REACT_APP_ENV || 'local',

	// A P I
	REACT_APP_API_URL: process.env.REACT_APP_API_URL || '',

	// S E N T R Y
	REACT_APP_SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN || '',

	// O N E S I G N A L
	REACT_APP_ONESIGNAL_ID: process.env.REACT_APP_ONESIGNAL_ID || '',

	// G O O G L E
	REACT_APP_GA_ID: process.env.REACT_APP_GA_ID || '',
	REACT_APP_MAPS_KEY: process.env.REACT_APP_MAPS_KEY || '',

	// P A Y S T A C K
	REACT_APP_PAYSTACK_PUB: process.env.REACT_APP_PAYSTACK_PUB || '',
};
